const colorDisplayNameOverrides: Record<string, string> = {
  'white-1': 'White',
};

/**
 * Converts an internal hyphen-case color identifier into a human-readable
 * Title Case name suitable for use as an ARIA label.
 *
 * Examples:
 *   "black"           → "Black"
 *   "dark-charcoal"   → "Dark Charcoal"
 *   "bubble-gum-pink" → "Bubble Gum Pink"
 *   "white-1"         → "White"  (override)
 */
export const getColorDisplayName = (colorName: string): string => {
  if (Object.prototype.hasOwnProperty.call(colorDisplayNameOverrides, colorName)) {
    // eslint-disable-next-line security/detect-object-injection
    return colorDisplayNameOverrides[colorName];
  }
  return colorName
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
